import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, Checkbox } from 'react-bootstrap'

export class LineDurationDraftForm extends Component {
    static contextTypes = {
        edition: PropTypes.object,
    }
    constructor(props){
        super(props);

        this.state = {
            noMinimumTimeErrorShow: false,
            noStartHourErrorShow: false,
            noEndHourErrorShow: false,
            invalidTimeRangeErrorShow: false
        };
    }

    onSave(){
        const { form } = this.props;
        const { minimumMinutes, startHour, endHour } = form.obj;

        const noMinimumTimeErrorShow = minimumMinutes === 0;
        const noStartHourErrorShow = startHour === undefined;
        const noEndHourErrorShow = endHour === undefined;
        const invalidTimeRangeErrorShow = startHour !== undefined && endHour !== undefined && startHour >= endHour;

        this.setState(
            {
                noMinimumTimeErrorShow,
                noStartHourErrorShow,
                noEndHourErrorShow,
                invalidTimeRangeErrorShow,
            },
            () => {
                if (!noMinimumTimeErrorShow && 
                    !noStartHourErrorShow && 
                    !noEndHourErrorShow && 
                    !invalidTimeRangeErrorShow) {
                    this.props.onSave();
                }
            }
        );
    }
    

    renderError(show, message) {
        return show ? <div style={{ color: 'red', marginLeft: '5px' }}>{message}</div> : null;
    }

    render() {
        const { form } = this.props;

        if(undefined === form) {
            return null;
        }

        const { show  } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formMinTime">
                            <ControlLabel>Tempo Mínimo de Minutos Entre Duas Paragens</ControlLabel>
                            <FormControl
                                type="number"
                                min="0"
                                value={form.obj.minimumMinutes || ''}
                                placeholder="Introduza o tempo mínimo em minutos"
                                onChange={(e) => this.props.onChangeValue(e, 'minimumMinutes')}
                            />
                        </FormGroup>
                        <FormGroup controlId="formUseMapPoints">
                            <Checkbox 
                                className="form-checkbox" 
                                defaultChecked={form.obj.useMapPoints} 
                                onChange={(e) => this.props.onCheckValue(e, "useMapPoints")}>
                                Utilizar Pontos Notáveis como Limite
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formStartHour">
                            <ControlLabel>Hora de Início</ControlLabel>
                            <FormControl
                                type="time"
                                value={form.obj.startHour || ''}
                                onChange={(e) => this.props.onChangeValue(e, 'startHour')}
                            />
                        </FormGroup>

                        <FormGroup controlId="formEndHour">
                            <ControlLabel>Hora de Fim</ControlLabel>
                            <FormControl
                                type="time"
                                value={form.obj.endHour || ''}
                                onChange={(e) => this.props.onChangeValue(e, 'endHour')}
                            />
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        {this.renderError(this.state.noMinimumTimeErrorShow, 'É necessário definir um tempo mínimo')}
                        {this.renderError(this.state.noStartHourErrorShow, 'É necessário definir uma hora de início')}
                        {this.renderError(this.state.noEndHourErrorShow, 'É necessário definir uma hora de fim')}
                        {this.renderError(this.state.invalidTimeRangeErrorShow, 'A hora de início deve ser menor que a hora de fim')}
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lines/LineDurationDraftForm.js